var map = {
	"./candlelight-more.png": "v010",
	"./dark-more.png": "Dfba",
	"./khalaspay-more.png": "6XfR",
	"./lavender-more.png": "ybu0",
	"./night-blue-more.png": "9qsD",
	"./orange-more.png": "bV3d",
	"./regular-more.png": "dr93"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "qUe0";


//////////////////
// WEBPACK FOOTER
// ./src/img ^\.\/.*\-more\.png$
// module id = qUe0
// module chunks = 9